module.exports = {
  attach: function() {
    const $confirmationPage = $('.confirmation-page');
    if ($confirmationPage.is('*')) {
        var products = {};
        var actionField = {};
        try {
            products = JSON.parse($('#gtm-orderConfirmation-products').attr('data-order-confirmation-products'));
        } catch (e) {
        };

        try {
            actionField = JSON.parse($('#gtm-orderConfirmation-products').attr('data-order-confirmation-action-field'))
        } catch (e) {
        };

        const purchaseProducts = {
            gtmData : {
                products: products,
                actionField: actionField
        }};

        $('body').trigger('gtm:eec:purchase', purchaseProducts);
        $('body').trigger('gtm:ga4:purchase', purchaseProducts);
      }
  }
}